import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { Application } from '@softline/application';

import { IconComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-app-list',
  templateUrl: './app-list.component.html',
  styleUrls: ['./app-list.component.css'],
  imports: [
    IconComponent,
    TranslatePipe
  ] })
export class AppListComponent {
  @Input() application!: Application;
  @Output() navigate = new EventEmitter<Application>();
  @Output() pinChange = new EventEmitter<boolean>();
  showColor = input<boolean>(false);
  pinned = input(false);
  canPin = input(true);

  goToApplication(application: Application): void {
    this.navigate.emit(application);
  }

  openInNewTab(application: Application, event: MouseEvent): void {
    event.stopPropagation();
    if (application.type === 'link') {
      if (application.href) window.open(application.href, '_blank');
    } else if (application.route) {
      window.open(window.location.origin + application.route, '_blank');
    }
  }
}
